// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1E90e","col":"Table_col__2tXrb","fulfillmentStatus":"Table_fulfillmentStatus__SRC_m","emailCol":"Table_emailCol__3aCHC"};